import WarningModal from "app/storybookComponents/Modals/WarningModal";
import { getPeopleOrPerson } from "utils/helperFunctions";
import { WEEKLY_CHECK_IN_FEATURE_NAME } from "../constants";

interface Props {
  isOpen: boolean;
  onHide: () => void;
  onConfirmClick: () => void;
  peopleCount?: number;
  isInProgress?: boolean;
}
const SendAllPendingCheckinReminderWarningModal = ({
  isOpen,
  onConfirmClick,
  onHide,
  peopleCount = 0,
  isInProgress,
}: Readonly<Props>) => (
  <WarningModal
    modalTitle="Send Reminder"
    hideModal={onHide}
    isOpen={isOpen}
    onConfirmClick={onConfirmClick}
    warningTitle={`Remind everyone who has not completed the ${WEEKLY_CHECK_IN_FEATURE_NAME}?`}
    warningMessage={`Send email reminders to ${peopleCount} ${getPeopleOrPerson(
      peopleCount
    )} who haven’t completed the check-in for this period.`}
    customButtonText="Send Reminders"
    isDanger={false}
    isInProgress={isInProgress}
  />
);

export default SendAllPendingCheckinReminderWarningModal;
